import script from "./AddUpdateQTypeCount.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUpdateQTypeCount.vue?vue&type=script&setup=true&lang=js"

export default script